
export default class ValidatorExtension {
    constructor() {
        ko.validation.rules['emailPattern'] = {
            validator: (emailAddress: string, usePattern: boolean) => {
                if (usePattern && emailAddress) {
                    var ptn = new RegExp((window as any).global.config.emailAddressRegex);
                    return ptn.test(emailAddress);
                } 
                return true;
            },
            message: 'Email address is invalid.'
        };

        ko.validation.rules['phonePattern'] = {
            validator: (phoneNumber: string, usePattern: boolean) => {
                if (usePattern && phoneNumber) {
                    var ptn = new RegExp('^\\s*[0-9][0-9\\s]*$');
                    return ptn.test(phoneNumber);
                }
                return true;
            },
            message: 'Phone number is invalid.'
        };

        ko.validation.registerExtenders();  
        
        ko.validation.init({
            insertMessages: false,
            decorateInputElement: true,
            errorElementClass: "is-invalid"
        }, true);    
    }
}